<div class="ws-product-detail__submit-bar"
     [ngClass]="{'py-3 px-sm-max-3 sticky-submit-button-wrapper': showAsSticky}"
     [class.sticky-submit-button-moved]="moveStickyBottomButtons">
  @if (showOnlySaveButton) {
    <div class="d-flex justify-content-center">
      <button
          class="btn ws-button ws-button--primary btn-block btn-footer ws-product-detail__submit"
          [disabled]="disabled"
          (click)="submit(false, false)">
        {{ saveButtonText || ('common.save' | translate) }}
      </button>
    </div>
  } @else {
    <div class="row">
      <div class="col-sm-6 d-flex justify-content-end">
        <button
            class="btn ws-button ws-button--danger btn-block btn-footer ws-product-detail__submit ws-product-detail__submit--more"
            [disabled]="disabled"
            (click)="submit(false, true)">
          <span>
            {{addMoreButtonText || ('cakeBuilder.footerSection.addToCartAndShopMore' | translate)}}
          </span>
        </button>
      </div>

      <div class="col-sm-6 d-flex">
        <button
            class="btn ws-button ws-button--primary btn-block btn-footer ws-product-detail__submit mt-xs-max-2"
            [disabled]="disabled"
            [translate]="'cakeBuilder.footerSection.continue'"
            (click)="submit(true, false)">
        </button>
      </div>
    </div>
  }
</div>
